import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getToken } from '../../utils/auth';

// The full "What is Pinion?" orientation page — reachable by anyone from the
// nav. Explains what Pinion is, how the Yes/No UI works, and what's OK to post.
export const About: React.FC = () => {
  const location = useLocation();
  const loggedIn = !!getToken();

  return (
    <div className="text-white max-w-app-middle-side mx-auto w-full px-app-base py-app-xl">
      {/* Hero */}
      <h1 className="text-app-3xl font-bold">
        What is <span className="text-app-primary">Pinion</span>?
      </h1>
      <p className="text-app-lg text-app-gray-light mt-app-base leading-relaxed">
        Pinion is a place for opinions you can answer in one tap. Each one — we call it a
        <span className="text-white"> Pinion</span> — has just two sides: <span className="text-app-primary font-semibold">Yes</span> or
        <span className="text-app-secondary font-semibold"> No</span>. Vote, see how everyone else
        answered, and discover the people who think like you.
      </p>

      {/* How it works */}
      <h2 className="text-app-xl font-bold mt-app-2xl">How it works</h2>

      <div className="flex items-center gap-app-lg mt-app-base">
        <span className="flex items-center gap-app-xs">
          <span className="inline-block w-app-2xl h-app-base-2 rounded-app-xs bg-app-primary" />
          <span className="text-app-primary font-semibold">Yes</span>
        </span>
        <span className="flex items-center gap-app-xs">
          <span className="inline-block w-app-2xl h-app-base-2 rounded-app-xs bg-app-secondary" />
          <span className="text-app-secondary font-semibold">No</span>
        </span>
      </div>

      <ol className="mt-app-base flex flex-col gap-app-base list-decimal pl-app-lg text-app-gray-light leading-relaxed">
        <li>Browse Pinions in the feed — each one is a simple Yes/No question.</li>
        <li>
          Tap <span className="text-app-primary font-semibold">Yes</span> or
          <span className="text-app-secondary font-semibold"> No</span> to cast your vote. The bar fills to
          show how the crowd split — <span className="text-app-primary">yellow for Yes</span>,
          <span className="text-app-secondary"> blue for No</span>.
        </li>
        <li>Jump into the comments to make your case or see what others think.</li>
        <li>
          <span className="text-white font-semibold">Soulmates:</span> the more your answers line up with
          someone else&apos;s, the higher they rank as your opinion soulmates.
        </li>
        <li>Have a question of your own? Create a Pinion and let the crowd decide.</li>
      </ol>

      {/* What's OK */}
      <h2 className="text-app-xl font-bold mt-app-2xl">What&apos;s OK</h2>
      <p className="text-app-gray-light mt-app-base">A few simple ground rules keep Pinion worth reading:</p>
      <ul className="mt-app-base flex flex-col gap-app-base list-disc pl-app-lg text-app-gray-light leading-relaxed">
        <li>Ask things that can genuinely be answered <span className="text-white">Yes</span> or <span className="text-white">No</span>.</li>
        <li>Keep it civil — argue with the opinion, not the person.</li>
        <li>No hate, harassment, or personal attacks.</li>
        <li>Keep it real — no spam, scams, or impersonation.</li>
      </ul>

      {/* CTA */}
      {!loggedIn && (
        <div className="mt-app-2xl flex flex-wrap gap-app-base">
          <Link
            to="/register"
            state={{ backgroundLocation: location }}
            className="bg-app-primary text-black font-semibold px-app-lg py-app-sm rounded-app-sm"
          >
            Create your account
          </Link>
          <Link
            to="/login"
            state={{ backgroundLocation: location }}
            className="border border-app-gray text-white px-app-lg py-app-sm rounded-app-sm hover:border-app-white"
          >
            Log in
          </Link>
        </div>
      )}
    </div>
  );
};
